import { render, staticRenderFns } from "./AriNashi.vue?vue&type=template&id=62d9acf6&scoped=true&"
import script from "./AriNashi.vue?vue&type=script&lang=js&"
export * from "./AriNashi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d9acf6",
  null
  
)

export default component.exports